import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from 'src/api/API';
import { useGetSurveyTopicGuideAnswers } from 'src/api/SurveyApi';
import { SurveyTypesHaveTopicGuide } from 'src/constants';
import { mapSurveyFormIdsFromSurveyTypes } from 'src/utils';
import { createContext, useContextSelector } from 'use-context-selector';
import { TopicGuideContextDefaultValue } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
dayjs.extend(weekOfYear);
var context = createContext(TopicGuideContextDefaultValue);
export var useTopicGuideContextSelector = function useTopicGuideContextSelector(selectorFn) {
  return useContextSelector(context, selectorFn);
};
export var Provider = function Provider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      showFloatTopicGuide = _useState[0],
      setShowFloatTopicGuide = _useState[1];

  var _useState2 = useState(false),
      isMemoAbleToAddOnFloatTopicGuide = _useState2[0],
      setIsMemoAbleToAddOnFloatTopicGuide = _useState2[1];

  var queryClient = useQueryClient();

  var _useRouter = useRouter(),
      clientID = _useRouter.query.clientID;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var toast = useToast();

  var _useGetSurveyTopicGui = useGetSurveyTopicGuideAnswers(clientID, SurveyTypesHaveTopicGuide),
      topicGuides = _useGetSurveyTopicGui.data,
      isPending = _useGetSurveyTopicGui.isPending,
      refetch = _useGetSurveyTopicGui.refetch;

  var showToast = useCallback(function (options) {
    toast(_objectSpread(_objectSpread({}, options), {}, {
      duration: 1000,
      isClosable: true,
      position: 'top'
    }));
  }, [toast]);
  var addSurveyMemoMutation = useMutation({
    mutationFn: function mutationFn(_ref2) {
      var text = _ref2.text,
          survey_answer_id = _ref2.survey_answer_id;
      return API.addSurveyMemo(clientID, text, survey_answer_id);
    },
    onSuccess: function onSuccess() {
      var surveyFormIds = mapSurveyFormIdsFromSurveyTypes(SurveyTypesHaveTopicGuide);
      queryClient.invalidateQueries({
        queryKey: ['getSurveyAnswers', clientID, surveyFormIds]
      });
      refetch();
      showToast({
        title: t('common:memo.successfullyCreatedMemo', 'memo 建立成功'),
        description: '',
        status: 'success'
      });
    },
    onError: function onError() {
      showToast({
        title: t('common:memo.memoCreationFailed', 'memo 建立失敗'),
        description: t('common:normal.pleaseTryAgainLater', '請稍後再試'),
        status: 'error'
      });
    }
  });
  var onAddMemo = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(text, survey_answer_id) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              addSurveyMemoMutation.mutate({
                text: text,
                survey_answer_id: survey_answer_id
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [addSurveyMemoMutation]);
  return /*#__PURE__*/_jsx(context.Provider, {
    value: {
      showFloatTopicGuide: showFloatTopicGuide,
      setShowFloatTopicGuide: setShowFloatTopicGuide,
      isMemoAbleToAddOnFloatTopicGuide: isMemoAbleToAddOnFloatTopicGuide,
      setIsMemoAbleToAddOnFloatTopicGuide: setIsMemoAbleToAddOnFloatTopicGuide,
      onAddMemo: onAddMemo,
      topicGuides: topicGuides,
      isGetTopicGuidesPending: isPending,
      isOnAddMemoMutatePending: addSurveyMemoMutation.isPending
    },
    children: children
  });
};